import { ValidationProtocolDTO } from "./validationProtocolDTO";

export class ValidationDefinitionDTO{

    public id!: number;
    public name!: string;
    public description!: string;
    public fileDefinitionId!: number;
    public validationProtocols!: ValidationProtocolDTO[];
    public version!: number; //incremental version number set by server
    public published!: boolean; //if true, then can be used for moovs and can be loaded by other users
    public added!: string;
    public deleted!: boolean;
    public ownedByEntityId!: number;
    public ownerEntityType!: string;

    constructor(){
        this.validationProtocols = new Array();
    }
}